import apiClient from "./client";

export default {
  getKpis: async () => {
    const response = await apiClient.get("/dashboard/kpis");
    return response.data;
  },
  getLastMobileSync: async () => {
    const response = await apiClient.get("/sync/last");
    return response.data;
  },
};

